module.exports = __webpack_public_path__ + "fonts/iconfont.23fc702.woff";